import angular from 'angular';
import uiRouter from 'angular-ui-router';
import mapComponent from './map.component';

let mapModule = angular.module('map', [
  uiRouter
])

.config(($stateProvider) => {
  "ngInject";
  $stateProvider
  .state('dashboard.detail.map', {
    url: '/map',
    component: 'map',
    params: {
      item: null
    }
  });
})

.component('map', mapComponent)

.name;

export default mapModule;



// WEBPACK FOOTER //
// ./client/app/components/dashboard/detail/map/map.js